import React, { useRef, useState } from "react";
import overlayVideo from "../files/banner.mp4";
import logo from "./logo-black.png.webp";
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "./firebase";
import { toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
import { websites } from "../constants/websites";
import AdminLogin from "./AdminLogin";
import { googleLogin, manualLogin } from "../redux/actionCreator";
import { saveSession } from "../utils/session";
import MfaChallenge from "./MfaChallenge";
import TechBackground from "./TechBackground";
import "./mfa.scss";
import "./login.scss";

const Login = () => {
  const { site } = useParams();
  const [admin, setAdmin] = useState(false);
  const [err, setErr] = useState({});
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const [mfa, setMfa] = useState(null); // {mfaToken, mfaSetup, otpauthUrl?, secret?}
  const cardRef = useRef(null);

  const onCardMouseMove = (e) => {
    const el = cardRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    el.style.setProperty("--tilt-x", `${(-y * 6).toFixed(2)}deg`);
    el.style.setProperty("--tilt-y", `${(x * 6).toFixed(2)}deg`);
    el.style.setProperty("--mx", `${(e.clientX - rect.left).toFixed(0)}px`);
    el.style.setProperty("--my", `${(e.clientY - rect.top).toFixed(0)}px`);
  };
  const onCardMouseLeave = () => {
    const el = cardRef.current;
    if (!el) return;
    el.style.setProperty("--tilt-x", `0deg`);
    el.style.setProperty("--tilt-y", `0deg`);
  };
  const onChangeHandler = (key, value) => {
    setData({
      ...data,
      [key]: value,
    });
    setErr({
      ...err,
      [key]: "",
    });
  };

  const onEnterLogin = (e) => {
    if (e.key == "Enter") {
      handleSubmit();
    }
  };

  const validate = () => {
    let temp = {};
    if (data?.email?.trim() == "") {
      temp = { ...temp, email: "Please enter email" };
    }
    // else {
    //   let regex = new RegExp(
    //     `/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/`
    //   );
    //   if (!regex.test(data?.email?.trim())) {
    //     temp = {
    //       ...temp,
    //       email: "Please enter valid email",
    //     };
    //   }
    // }
    if (data?.password.trim() == "") {
      temp = { ...temp, password: "Please enter password" };
    }
    if (Object.values(temp).length != 0) {
      setErr(temp);
      return false;
    } else {
      setErr({});
      return true;
    }
  };

  const handleSubmit = async () => {
    if (validate()) {
      let value = {
        email: data?.email,
        password: data?.password,
      };

      console.log(value);
      try {
        const response = await manualLogin(value);
        const body = response?.data;
        if (body?.mfaRequired) {
          setMfa(body);
          return;
        }
        if (body?.status) {
          saveSession({
            _id: body._id,
            email: body.email,
            role: body.role,
            firstname: body.firstname,
            lastname: body.lastname,
            name: body.displayName,
          });
          if (websites?.[site]) {
            window.location.replace(websites[site] + (body.accessToken || ""));
          } else {
            window.location.href = "/dashboard";
          }
        } else {
          toast.error(body?.message || "Login failed", {
            position: "bottom-center",
            autoClose: 3000,
          });
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Login failed", {
          position: "bottom-center",
          autoClose: 3000,
        });
      }
    }
  };

  const handleGoogleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const token = await result.user.getIdToken();
      // Backend reads the real client IP from req.ip (trust proxy is on),
      // so we don't need to send anything here.
      let data = { idToken: token };
      const response = await googleLogin(data);
      const body = response?.data;
      if (body?.mfaRequired) {
        setMfa(body);
        return;
      }
      if (body?.status) {
        saveSession(body.user || { email: data.email });
        if (websites?.[site]) {
          window.location.replace(websites[site] + (body.accessToken || ""));
        } else {
          window.location.href = "/dashboard";
        }
      } else {
        toast.error(body?.message || "Login failed", {
          position: "bottom-center",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.log("1")
      // toast.error("Login failed", {
      //   position: "bottom-center",
      //   autoClose: 3000,
      // });
      console.error(error);
    }
  };

  return (
    <div className="security__login tech-theme">
      <TechBackground />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 pe-0">
            <div
              className="login__section"
              ref={cardRef}
              onMouseMove={onCardMouseMove}
              onMouseLeave={onCardMouseLeave}
            >
              <div className="logo-wrap">
                <span className="logo-ring logo-ring--1" />
                <span className="logo-ring logo-ring--2" />
                <span className="logo-orbit">
                  <span className="logo-orbit__dot" />
                </span>
                <img src={logo} alt="Smart Hatch Technologies" className="logo" />
              </div>
              <br />
              {mfa ? (
                <MfaChallenge
                  challenge={mfa}
                  onCancel={() => setMfa(null)}
                  onSuccess={() => {
                    if (websites?.[site]) {
                      window.location.replace(websites[site]);
                    } else {
                      window.location.href = "/dashboard";
                    }
                  }}
                />
              ) : admin ? (
                <AdminLogin setAdmin={setAdmin} onMfa={setMfa} />
              ) : (
                <>
                  <h2>Welcome back, Smarthatch Security!</h2>
                  <button onClick={handleGoogleLogin} className="btn-primary">
                    <img src="/google.svg" alt="" /> Login with Google
                  </button>
                  <Link
                    onClick={() => setAdmin(!admin)}
                    className="admin_login mt-3"
                  >
                    Admin login
                  </Link>
                  <Link to="/register" className="admin_login mt-2">
                    Don't have an account? Request access
                  </Link>
                </>
              )}

            </div>
          </div>
        </div>
        <p className="m-0 copyright">© SMART HATCH TECHNOLOGIES FZE</p>
      </div>
    </div>
  );
};

export default Login;
